const CLIENTS = [
  { src: "/images/clients/abm-polytechnic.webp", name: "ABM Polytechnic, Sri Vijayapuram" },
  { src: "/images/clients/britech-it.webp", name: "BRITECH IT Education and Training" },
  { src: "/images/clients/aiecce.webp", name: "All India Early Childhood Care & Education, New Delhi" },
  { src: "/images/clients/dpmi.webp", name: "DPMI — Delhi Paramedical & Management Institute" },
  { src: "/images/clients/abode-care.webp", name: "Abode Care Maintenance Pvt. Ltd." },
  { src: "/images/clients/24x7-software.webp", name: "24x7 Software Services — Business Automation & ERP Solutions" },
  { src: "/images/clients/eurekha-kids.webp", name: "Eurekha Kids Pre-School" },
  { src: "/images/clients/saaf-safai-wale.webp", name: "Saaf Safai Wale — Clean Spaces, Better Lives" },
];

export default function ClientLogos() {
  const strip = [...CLIENTS, ...CLIENTS];
  return (
    <section data-testid="client-logos-section" className="py-14 bg-white border-y border-gray-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-center font-display text-2xl sm:text-3xl font-bold tracking-tight text-[#B01116] mb-10">
          Brands That Trust Gold Mind Business
        </h2>
      </div>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 w-16 sm:w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-16 sm:w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
        <div className="gmb-marquee flex items-center gap-14 sm:gap-20 w-max">
          {strip.map((c, i) => (
            <img
              key={`${c.name}-${i}`}
              src={c.src}
              alt={c.name}
              title={c.name}
              loading="lazy"
              decoding="async"
              data-testid={`client-logo-${i % CLIENTS.length}`}
              className="h-20 sm:h-24 w-auto object-contain flex-none"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
